import postAPI from './postAPI.js'

export default async function postReorderSteps(taskFlowId, stepIds) {
    const data = await postAPI('admin/taskflows/steps/reorder', {
        task_flow_id: taskFlowId,
        step_ids: stepIds
    });
    return data;
}
